var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { BenefitCardMW, BenefitCardFullWidthDTW, BenefitCardHalfWidthDTW, } from '../../../shared/rewards-hub';
import { getImageURL } from '../../../../utils/GeneralUtil';
import { analyticsStash } from '../../../../utils/analytics';
import { rhAnalytics } from '../../../../constants/RewardsHub';
var constants = {
    title: "Elite Support Line",
    headline: '(888) 555-1234',
    mobileHeadline: function (props) { return (React.createElement("a", { href: "tel:".concat(props.phoneNumber), onClick: function () {
            analyticsStash(rhAnalytics.eliteSupportLine);
        } }, props.phoneNumber)); },
    subtitle: "Unlock access to an exclusive phone line dedicated only to our Elite Members and receive priority support from a program expert.",
    iconUrl: getImageURL("WelcomeCard/active_ESL.svg"),
};
var EliteSupportLineMW = function (props) {
    var isLocked = props.isLocked, phoneNumber = props.phoneNumber;
    var data = __assign(__assign({}, props), { isLocked: isLocked, headline: !isLocked ? (React.createElement(constants.mobileHeadline, { phoneNumber: phoneNumber })) : undefined, iconUrl: constants.iconUrl, title: constants.title, subtitle: constants.subtitle });
    return React.createElement(BenefitCardMW, __assign({}, data));
};
var EliteSupportLineFullWidthDTW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, subtitle: constants.subtitle, headline: !isLocked ? constants.headline : undefined });
    return React.createElement(BenefitCardFullWidthDTW, __assign({}, data));
};
var EliteSupportLineHalfWidthDTW = function (props) {
    var isLocked = props.isLocked, phoneNumber = props.phoneNumber;
    var data = __assign(__assign({}, props), { isLocked: isLocked, headline: !isLocked ? phoneNumber : undefined, iconUrl: constants.iconUrl, title: constants.title, subtitle: constants.subtitle });
    return React.createElement(BenefitCardHalfWidthDTW, __assign({}, data));
};
export var EliteSupportLine = function (props) {
    var isMobile = props.isMobile, isLocked = props.isLocked, fullWidth = props.fullWidth, phoneNumber = props.phoneNumber;
    var mockProp = props.mockProp; // TODO: Remove after demo
    var data = { isMobile: isMobile, isLocked: isLocked, phoneNumber: phoneNumber };
    if (isMobile)
        return React.createElement(EliteSupportLineMW, __assign({}, data));
    // if (fullWidth) return <BusinessToolsHalfWidthDTW {...data} />;
    // return <BusinessToolsHalfWidthDTW {...data} />;
    // For Demo
    if (fullWidth)
        return React.createElement(EliteSupportLineFullWidthDTW, __assign({}, data, { mockProp: mockProp }));
    return React.createElement(EliteSupportLineHalfWidthDTW, __assign({}, data, { mockProp: mockProp }));
};
